












import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ContractTable from '@contracts/components/tables/contract-table/contract-table.vue';

@Component({
  name: 'bpc-profile-contracts',
  components: {
    'bpc-contract-table': ContractTable,
  },
})
export default class ProfileContracts extends Vue {
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get contactId() {
    return this.$authorizationService.getContactId();
  }

  get filterByContactId() {
    return [{ filterField: 'contact_id', modelField: null, value: this.contactId }];
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
